import { useDebug } from "../../debug";

export function Helpers() {
	const { debugEnabled } = useDebug();

	if (!debugEnabled) return null;

	return (
		<>
			<axesHelper scale={1} position={[0, 0, 0]} />
		</>
	);
}
